<router-outlet></router-outlet>
<app-idle></app-idle>
